document.addEventListener("DOMContentLoaded", function () {
    const quickViewButtons = document.querySelectorAll(".quick-view-button");
    const modal = document.getElementById("quick-view-modal");
    const modalContent = document.getElementById("quick-view-content");
    const closeModal = document.querySelector(".close-modal");
    let selectedVariantId = null;
    let selectedVariantTitle = "";

    // Event listener to open Quick View modal and fetch product data
    quickViewButtons.forEach(button => {
        button.addEventListener("click", function () {
            const productHandle = this.getAttribute("data-product-handle");

            // Fetch product data by handle
            fetch(`/products/${productHandle}.js`)
                .then(response => response.json())
                .then(product => {
                    // Build variant buttons and set initial selected variant
                    let variantButtons = '';
                    product.variants.forEach((variant, index) => {
                        variantButtons += `
                            <button class="${variant.available === false ? 'pointer-events-none disabled' : ''}  variant-button ${index === 0 ? 'active' : ''}" data-variant-id="${variant.id}" data-variant-title="${variant.option2}" data-variant-price="${variant.price}" data-variant-compare_at_price="${variant.compare_at_price}">
                                ${variant.option2}
                            </button>
                        `;
                        if (index === 0) {
                            selectedVariantId = variant.id;
                            selectedVariantTitle = variant.option2;
                        }
                    });

                    // Populate modal with product details
                    modalContent.innerHTML = `
                        <img src="${product.images[0]}" alt="${product.title}" />
                        <div class="quick-view-modal_product-info">
                            <span class="quick-view-modal_vendor">${product.vendor}</span>
                            <span class="quick-view-modal_name">${product.title}</span>
                            <div class="quick-view-modal_price-wrapper">
                                <span class="quick-view-modal_price-current ${product.variants[0].compare_at_price ? 'compare' : ''}">$${(product.variants[0].price / 100).toFixed(2)}</span>
                                <span class="quick-view-modal_price-compare ${product.variants[0].compare_at_price ? '' : 'hidden'}">$${(product.variants[0].compare_at_price / 100).toFixed(2)}</span>
                                <div class="yotpo-widget-instance"
                                    data-yotpo-instance-id="847316"
                                    data-yotpo-product-id="${product.id}"
                                    data-yotpo-section-id="product">
                                </div>
                            </div>
                            <div id="selected-variant-display" class="selected-variant-display">Size - ${selectedVariantTitle}</div>
                            <div class="variant-buttons-container">
                                ${variantButtons}
                            </div>
                            <button id="add-to-cart-button" class="add-to-cart-button">Add to cart</button>
                            <a href="/pages/store-locator" id="find-in-store-button" class="find-in-store-button">Find in store</a>
                        </div>
                    `;
                    modal.style.display = "flex";

                    // Initialize Yotpo widget
                    if (yotpoWidgetsContainer) {
                        yotpoWidgetsContainer.initWidgets();
                    }
                })
                .catch(error => console.error("Error fetching product data:", error));
        });
    });

    // Event listener to update variant selection and price display
    document.addEventListener("click", function (event) {
        if (event.target && event.target.classList.contains("variant-button")) {
            // Deselect all variant buttons and mark the clicked button as active
            document.querySelectorAll(".variant-button").forEach(button => button.classList.remove("active"));
            event.target.classList.add("active");

            // Retrieve selected variant data
            const variantId = event.target.getAttribute("data-variant-id");
            const variantTitle = event.target.getAttribute("data-variant-title");
            const variantPrice = parseFloat(event.target.getAttribute("data-variant-price")) / 100;
            const variantCompareAtPrice = event.target.getAttribute("data-variant-compare_at_price");

            if (variantId) {
                selectedVariantId = variantId;
                selectedVariantTitle = variantTitle;

                // Update price display
                const currentPriceElement = document.querySelector(".quick-view-modal_price-current");
                const comparePriceElement = document.querySelector(".quick-view-modal_price-compare");

                currentPriceElement.innerText = `$${variantPrice.toFixed(2)}`;
                const hasComparePrice = variantCompareAtPrice !== "null";

                // Toggle compare price visibility
                if (hasComparePrice) {
                    comparePriceElement.innerText = `$${(parseFloat(variantCompareAtPrice) / 100).toFixed(2)}`;
                    currentPriceElement.classList.add("compare");
                    comparePriceElement.classList.remove("hidden");
                } else {
                    currentPriceElement.classList.remove("compare");
                    comparePriceElement.classList.add("hidden");
                }

                // Update selected variant display
                document.getElementById("selected-variant-display").innerText = `Size - ${selectedVariantTitle}`;
            } else {
                console.error("Error: Variant ID not found.");
            }
        }
    });


    // Event listener for adding selected variant to the cart
    document.addEventListener("click", function (event) {
        if (event.target && event.target.id === "add-to-cart-button") {
            if (!selectedVariantId) {
                console.warn("Please select a variant before adding to cart.");
                return;
            }

            Neptune.cart.add(selectedVariantId)
                .then(() => {
                    modal.style.display = "none";
                })
                .catch(error => console.error("Error adding to cart:", error));
        }
    });

    // Close modal when clicking on the close button
    closeModal.addEventListener("click", function () {
        modal.style.display = "none";
    });

    // Close modal when clicking outside of it
    window.addEventListener("click", function (event) {
        if (event.target === modal) {
            modal.style.display = "none";
        }
    });
});
